import { Component, Input, AfterViewInit } from '@angular/core';

@Component({
    selector: 'circle-progress',
    template: `
    <div class="circle-progress-container" [style.width.px]="size" [style.height.px]="size">
      <svg [attr.width]="size" [attr.height]="size" [attr.viewBox]="'0 0 ' + size + ' ' + size">
        <circle
          [attr.cx]="center" [attr.cy]="center" [attr.r]="radius"
          fill="none" [attr.stroke]="outerStrokeColor"
          [attr.stroke-width]="strokeWidth" opacity="0.25" />
        <circle
          [attr.cx]="center" [attr.cy]="center" [attr.r]="radius"
          fill="none" [attr.stroke]="outerStrokeColor"
          [attr.stroke-width]="strokeWidth" stroke-linecap="round"
          [attr.stroke-dasharray]="circumference"
          [attr.stroke-dashoffset]="currentDashOffset"
          [style.transform]="'rotate(-90deg)'"
          [style.transform-origin]="'center'"
          [style.transition]="'stroke-dashoffset 0.6s ease'" />
        <text
          [attr.x]="center" [attr.y]="center - 5"
          text-anchor="middle" dominant-baseline="central"
          [attr.fill]="titleColor" [attr.font-size]="titleFontSize"
          font-weight="bold">
          {{ displayPercent }}<tspan [attr.font-size]="titleFontSize * 0.6">{{ units }}</tspan>
        </text>
        @if (showSubtitle) {
          <text
            [attr.x]="center" [attr.y]="center + subtitleFontSize"
            text-anchor="middle" dominant-baseline="central"
            [attr.fill]="subtitleColor" [attr.font-size]="subtitleFontSize">
            {{ subtitle }}
          </text>
        }
      </svg>
    </div>
    `,
    styles: [`
    .circle-progress-container {
      position: relative;
      display: inline-block;
      max-width: 100%;
    }
    svg {
      width: 100%;
      height: auto;
    }
  `]
})
export class CircleProgressComponent implements AfterViewInit {
  @Input() percent: number = 0;

  readonly radius = 80;
  readonly strokeWidth = 6;
  readonly outerStrokeColor = '#00BC8C';
  readonly titleColor = '#FFFFFF';
  readonly titleFontSize = 30;
  readonly units = '%';
  readonly showSubtitle = true;
  readonly subtitle = 'Finished';
  readonly subtitleColor = '#FFFFFF';
  readonly subtitleFontSize = 20;

  currentDashOffset = 0;
  displayPercent = 0;

  get size(): number {
    return (this.radius + this.strokeWidth) * 2;
  }

  get center(): number {
    return this.size / 2;
  }

  get circumference(): number {
    return 2 * Math.PI * this.radius;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.displayPercent = this.percent;
      this.currentDashOffset = this.circumference * (1 - this.percent / 100);
    }, 50);
  }
}
